import { render, staticRenderFns } from "./borrowView.vue?vue&type=template&id=34dc9b48&scoped=true&"
import script from "./borrowView.vue?vue&type=script&lang=js&"
export * from "./borrowView.vue?vue&type=script&lang=js&"
import style0 from "./borrowView.vue?vue&type=style&index=0&id=34dc9b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dc9b48",
  null
  
)

export default component.exports